// frontend/optica-frontend/src/utils/proveedores.js
import { authService } from '../api/auth';

export const BACKEND_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
export const API_V2_URL = `${BACKEND_URL}/api/v2`;

// =============== HELPERS ===============

function headersToObject(headers) {
  if (!headers) return {};
  if (headers instanceof Headers) {
    const obj = {};
    headers.forEach((value, key) => { obj[key] = value; });
    return obj;
  }
  return { ...headers };
}

function getAuthHeaders() {
  const token = authService.obtenerToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function buildRequestHeaders(extraHeaders = {}) {
  const headers = new Headers();
  const authHeaders = getAuthHeaders();

  Object.entries(authHeaders).forEach(([key, value]) => {
    headers.append(key, value);
  });

  Object.entries(headersToObject(extraHeaders)).forEach(([key, value]) => {
    headers.append(key, value);
  });

  return headers;
}

async function parseErrorDetail(response) {
  try {
    const data = await response.json();
    if (Array.isArray(data.detail)) {
      return data.detail
        .map((err) => {
          const field = Array.isArray(err.loc) ? err.loc[err.loc.length - 1] : '';
          return field ? `${field}: ${err.msg}` : (err.msg || JSON.stringify(err));
        })
        .join(' | ');
    }
    if (typeof data.detail === 'object' && data.detail !== null) {
      return data.detail.message || data.detail.msg || JSON.stringify(data.detail);
    }
    return data.detail || data.message || 'Error desconocido';
  } catch {
    return `Error ${response.status}`;
  }
}

async function apiFetch(url, options = {}) {
  const headers = buildRequestHeaders(options.headers);

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const detail = await parseErrorDetail(response);
    const error = new Error(detail);
    error.status = response.status;
    throw error;
  }

  return response;
}

// =============== FUNCIONES PARA PROVEEDORES ===============

export const obtenerProveedores = async () => {
  try {
    const response = await apiFetch(`${API_V2_URL}/proveedores/`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    const data = await response.json();
    return data.proveedores || [];
  } catch (e) {
    console.error('Error en obtenerProveedores:', e.message);
    throw e;
  }
};

export const obtenerProveedorPorId = async (proveedorId) => {
  try {
    const response = await apiFetch(`${API_V2_URL}/proveedores/${proveedorId}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    return await response.json();
  } catch (e) {
    console.error('Error en obtenerProveedorPorId:', e.message);
    throw e;
  }
};

export const crearProveedor = async (proveedor) => {
  try {
    const payload = {
      nombre_vendedor: '',
      telefono: '',
      direccion: '',
      cuit: '',
      ...proveedor,
      nombre: (proveedor?.nombre || '').trim(),
    };
    const response = await apiFetch(`${API_V2_URL}/proveedores/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    return await response.json();
  } catch (e) {
    console.error('Error en crearProveedor:', e.message);
    throw e;
  }
};

export const actualizarProveedor = async (proveedorId, proveedor) => {
  try {
    const response = await apiFetch(`${API_V2_URL}/proveedores/${proveedorId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(proveedor),
    });
    return await response.json();
  } catch (e) {
    console.error('Error en actualizarProveedor:', e.message);
    throw e;
  }
};

export const eliminarProveedor = async (proveedorId) => {
  try {
    const response = await apiFetch(`${API_V2_URL}/proveedores/${proveedorId}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    });
    return await response.json();
  } catch (e) {
    console.error('Error en eliminarProveedor:', e.message);
    throw e;
  }
};

export const asignarMarcasProveedor = async (proveedorId, marcaIds) => {
  try {
    const response = await apiFetch(`${API_V2_URL}/proveedores/${proveedorId}/marcas`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ marca_ids: marcaIds }),
    });
    return await response.json();
  } catch (e) {
    console.error('Error en asignarMarcasProveedor:', e.message);
    throw e;
  }
};
